import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Mesure } from 'src/app/shared/models/mesure';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-edit-parametrage-unite-mesure',
  templateUrl: './edit-parametrage-unite-mesure.component.html',
  styleUrl: './edit-parametrage-unite-mesure.component.scss'
})

export class EditParametrageUniteMesureComponent {
  item: Mesure = new Mesure();
  items: any =[];
  departementItems: any;
  categorieProduitItems: any;
  uniteItems: any;
  etatProduitItems: any;
  varieteItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;

  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.item.user_id = this.localStorage.getUsers()?.data?.reference;
    this.items = this.localStorage.getUniteMesure();
    this.item = this.localStorage.getUniteMesure();

  }



  close() {

    this.modalService.dismissAll();
  }

  updateMesure() {
    // if (!this.item.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.item.getErrorMessage() });
    //   return;
    // } 
    //else {
      this.item.unite_id = this.items.reference
      this.ngxservice.start();   
      this.paramService.editMesure(this.item).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "AfriCereal",
            detail: response.message,
          });
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "AfriCereal",
            detail: error,
          });
        }
      );
  //  }
  }

}
